<template>
    <div>
        <Header></Header>
        <div>
            <div class="card-block">
                <h1>Парковка #{{ $route.params.id }}<router-link class="button _free _second" to="/parking">К списку</router-link></h1>
                <div class="tabs">
                    <router-link to="common">Общее</router-link>
                    <router-link to="slot">Слоты</router-link>
                    <router-link to="price">Цены</router-link>
                    <router-link to="discount">Скидки</router-link>
                    <router-link to="configuration">Параметры парковки</router-link>
                    <router-link to="information">Информация</router-link>
                    <router-link to="timetable">Расписание</router-link>
                    <router-link to="assistant">Доверенные лица</router-link>
                    <router-link to="booking">Букинг</router-link>
                    <router-link to="occupation">Загруженность</router-link>
                    <router-link to="transaction">Транзакции</router-link>
                    <router-link to="qr">QR code</router-link>
                </div>
                <router-view :loading="status_request" :data.sync="data" :status="status" @showPopup="showPopup" @getData="getData" @updateData="updateData"></router-view>
                <div class="page-load" v-show="status == 'loading'">
                    <div class="inline" valign="center">
                        <img src="~@/assets/img/preloader.svg" class="preloader"> Загрузка
                    </div>
                </div>

                <div class="submit button _free" v-show="showButton" @click="update()">Сохранить</div>
            </div>
        </div>
        <Logs :data.sync="popup"></Logs>
        <Rollback v-if="popup.active == 'rollback'" :data.sync="popup" @rollbackSuccess="rollbackSuccess()"></Rollback>
    </div>
</template>

<script>
    import Header from '@/components/Header.vue'
    import Logs from '@/components/Logs.vue'
    import Rollback from '@/components/Rollback.vue'

    import popups from '@/mixins/popups'

    export default {
        mixins: [popups],
        components: {
            Header,
            Logs,
            Rollback
        },
        data () {
            return {
                data: {},
                data_backup: false,
                status_request: 'init',
                status: 'init',
                saved_get_params: false
            }
        },
        computed: {
            showButton () {
                if (JSON.stringify(this.data) == this.data_backup || this.status != '' || this.activeSection == 'slot' || this.activeSection == 'transaction') {
                    return false
                }
                return true
            },
            activeSection() {
                return this.$route.path.substr(this.$route.path.lastIndexOf('/') + 1)
            }
        },
        methods: {
            rollbackSuccess () {
                this.data.rollback_possible = false
                this.savedata()
            },
            savedata () {
                this.data_backup = JSON.stringify(this.data)
            },
            update () {
                let json = JSON.stringify(this.data)
                let method_name = this.activeSection
                if (this.saved_get_params) {
                    method_name += '?' + this.saved_get_params
                }
                return new Promise((resolve, reject) => {
                    this.status_request = 'loading'
                    this.axios.post('api/admin/v2/parking/' + this.$route.params.id + '/' + method_name, json, {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }).then((resp) => {
                        this.status_request = ''
                        this.data = resp.data.response
                        this.savedata()
                        let msg = {
                            message: 'Данные обновлены',
                            status: 'success'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        resolve()
                    }).catch(() => {
                        this.status_request = ''
                        let msg = {
                            message: 'Ошибка при обновлении данных',
                            status: 'error'
                        }
                        this.$store.dispatch('utils/showMessage', msg)
                        reject()
                    })
                })
            },
            getData(e = false) {
                return new Promise((resolve) => {
                    this.status = 'loading'
                    let method_name = this.activeSection
                    if (e) {
                        method_name += '?' + e
                        this.saved_get_params = e
                    }
                    this.axios.get('api/admin/v2/parking/' + this.$route.params.id + '/' + method_name)
                        .then(resp => {
                            this.data = resp.data.response
                            this.savedata()
                            this.status = ''
                            resolve()
                        })
                        .catch(() => {
                            this.$router.push('/parking')
                        })
                })
            },
            updateData(data) {
                this.data = data
                this.savedata()
            }
        },
        created () {
            let self = this
            this.$router.beforeEach((to, from, next) => {
                self.data = {}
                self.status = 'loading'
                next()
            })
        }
    }
</script>
